/**
 * What the ops shortcut provider (useKeyboardShortcuts.tsx) does with a key
 * for Escape. Pure so the rule is testable without a DOM.
 *
 *   'close'   — Escape nobody above has used: close the topmost ops drawer;
 *   'claimed' — Escape something above already used (preventDefault):
 *               leave every ops drawer open;
 *   null      — not Escape.
 *
 * PR 10 review: the product quick view (components/overlay/Drawer) can open
 * ON TOP of an ops drawer — the Listing detail drawer's thumbnail opens it.
 * The overlay kit handles Escape on `document` and says so with
 * preventDefault(); this provider listens on `window`, which the same event
 * reaches next, and closed its own drawer too — one Escape closed both
 * layers. A key something above already used is not ours: the same
 * `defaultPrevented` convention the overlay kit follows (useOverlay.ts).
 */
export function escapeKeyAction(
  e: Pick<KeyboardEvent, 'key' | 'defaultPrevented'>,
): 'close' | 'claimed' | null {
  if (e.key !== 'Escape') return null
  return e.defaultPrevented ? 'claimed' : 'close'
}
